import { ItemStatus } from "../aidwops.types";

const AlertIcon = (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_651_3805)">
            <g clipPath="url(#clip1_651_3805)">
                <path
                    d="M6.74852 8.54995C6.74852 8.9641 6.41283 9.29978 5.99868 9.29978C5.58453 9.29978 5.24884 8.9641 5.24884 8.54995C5.24884 8.1361 5.58453 7.80011 5.99868 7.80011C6.41283 7.80011 6.74852 8.1361 6.74852 8.54995ZM5.99868 3.60103C6.32999 3.60103 6.59855 3.86965 6.59855 4.2009V6.60037C6.59855 6.93192 6.32999 7.20024 5.99868 7.20024C5.66737 7.20024 5.39881 6.93192 5.39881 6.60037V4.2009C5.39881 3.86965 5.66737 3.60103 5.99868 3.60103ZM7.1043 0.605464C6.42393 0.200372 5.57619 0.200672 4.89564 0.605464C4.58845 0.788544 4.36056 1.07702 4.1536 1.39747C3.94665 1.71762 3.7151 2.14407 3.42872 2.67189C3.42872 2.67189 0.396144 8.25967 0.250796 8.5848C0.104248 8.91227 -0.00642821 9.24004 0.000290318 9.581C0.015347 10.342 0.430156 11.0391 1.09199 11.4155C1.38839 11.5839 1.72911 11.6431 2.08699 11.6706C2.442 11.6978 2.89178 11.6978 3.44486 11.6978C3.44486 11.6978 9.558 11.6978 9.913 11.6706C10.2709 11.6431 10.6116 11.5839 10.908 11.4155C11.5698 11.0391 11.9847 10.3419 11.9997 9.581C12.0064 9.24004 11.8958 8.91233 11.7492 8.58486C11.6038 8.25973 11.3893 7.8643 11.1255 7.3784C11.1255 7.3784 8.05335 1.71774 7.8464 1.39759C7.63944 1.07714 7.41155 0.788424 7.1043 0.605464ZM5.50919 1.63652C5.81158 1.4565 6.18836 1.45668 6.49081 1.63652C6.55224 1.67311 6.65698 1.76747 6.83886 2.04863C7.0178 2.32541 7.22763 2.71118 7.52901 3.26654C7.52901 3.26654 10.5298 8.79661 10.6541 9.07453C10.7794 9.35485 10.8017 9.48574 10.8002 9.55725C10.7935 9.89557 10.6092 10.2052 10.315 10.3724C10.2529 10.4079 10.1273 10.4506 9.82123 10.4743C9.51763 10.4975 9.11422 10.4981 8.53013 10.4981C8.53013 10.4981 2.48243 10.4975 2.17883 10.4743C1.87278 10.4506 1.74717 10.4079 1.68502 10.3724C1.39085 10.2052 1.20651 9.89557 1.19985 9.55725C1.19841 9.4858 1.22066 9.35485 1.34598 9.07453C1.47027 8.79655 1.66235 8.44185 1.94099 7.92842C1.94099 7.92842 4.98226 2.32547 5.1612 2.04863C5.34302 1.76741 5.44776 1.67311 5.50919 1.63652Z"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="#745D12"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_651_3805">
                <rect width="12" height="12" fill="white" />
            </clipPath>
            <clipPath id="clip1_651_3805">
                <rect
                    width="12"
                    height="11.3961"
                    fill="white"
                    transform="translate(0 0.301758)"
                />
            </clipPath>
        </defs>
    </svg>
);

const DeclineIcon = (
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.48384 4.98405L6.7337 6.73419M6.7337 6.73419L4.98356 8.48433M6.7337 6.73419L4.98356 4.98405M6.7337 6.73419L8.48384 8.48433M12.5675 6.73419C12.5675 9.95611 9.95562 12.568 6.7337 12.568C3.51178 12.568 0.899902 9.95611 0.899902 6.73419C0.899902 3.51227 3.51178 0.900391 6.7337 0.900391C9.95562 0.900391 12.5675 3.51227 12.5675 6.73419Z"
            strokeWidth="1.8"
            strokeLinecap="round"
            stroke="#BB2735"
        />
    </svg>
);

const SuccessIcon = (
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.98356 6.73419L6.15032 7.90095L8.48384 5.56743M12.5675 6.73419C12.5675 9.95611 9.95562 12.568 6.7337 12.568C3.51178 12.568 0.899902 9.95611 0.899902 6.73419C0.899902 3.51227 3.51178 0.900391 6.7337 0.900391C9.95562 0.900391 12.5675 3.51227 12.5675 6.73419Z"
            strokeWidth="1.8"
            strokeLinecap="round"
            stroke="#147452"
        />
    </svg>
);

const RecommendedActionIcon = (
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.4022 0.90153V2.06815M11.4022 2.06815V3.23477M11.4022 2.06815H12.5689M11.4022 2.06815H10.2354M6.16164 1.3766C6.18664 1.24279 6.25765 1.12194 6.36238 1.03497C6.46711 0.947998 6.59896 0.900391 6.7351 0.900391C6.87124 0.900391 7.0031 0.947998 7.10783 1.03497C7.21256 1.12194 7.28357 1.24279 7.30857 1.3766L7.9217 4.61864C7.96525 4.84913 8.07727 5.06115 8.24316 5.22702C8.40904 5.39288 8.62109 5.5049 8.85161 5.54844L12.094 6.1615C12.2279 6.18649 12.3487 6.25749 12.4357 6.36221C12.5227 6.46693 12.5703 6.59877 12.5703 6.73489C12.5703 6.87101 12.5227 7.00285 12.4357 7.10757C12.3487 7.21229 12.2279 7.28329 12.094 7.30829L8.85161 7.92134C8.62109 7.96489 8.40904 8.0769 8.24316 8.24277C8.07727 8.40863 7.96525 8.62065 7.9217 8.85114L7.30857 12.0932C7.28357 12.227 7.21256 12.3478 7.10783 12.4348C7.0031 12.5218 6.87124 12.5694 6.7351 12.5694C6.59896 12.5694 6.46711 12.5218 6.36238 12.4348C6.25765 12.3478 6.18664 12.227 6.16164 12.0932L5.54851 8.85114C5.50496 8.62065 5.39293 8.40863 5.22705 8.24277C5.06116 8.0769 4.84912 7.96489 4.6186 7.92134L1.37617 7.30829C1.24235 7.28329 1.12148 7.21229 1.0345 7.10757C0.947515 7.00285 0.899902 6.87101 0.899902 6.73489C0.899902 6.59877 0.947515 6.46693 1.0345 6.36221C1.12148 6.25749 1.24235 6.18649 1.37617 6.1615L4.6186 5.54844C4.84912 5.5049 5.06116 5.39288 5.22705 5.22702C5.39293 5.06115 5.50496 4.84913 5.54851 4.61864L6.16164 1.3766ZM3.23485 11.4011C3.23485 12.0454 2.71247 12.5677 2.06809 12.5677C1.4237 12.5677 0.901327 12.0454 0.901327 11.4011C0.901327 10.7568 1.4237 10.2345 2.06809 10.2345C2.71247 10.2345 3.23485 10.7568 3.23485 11.4011Z"
            strokeWidth="1.8"
            strokeLinecap="round"
            stroke="#275FC2"
        />
    </svg>
);

const ExpertQueueCardStatusIcon = ({ status }: { status: ItemStatus }) => {
    switch (status) {
        case "awaiting_review":
            return RecommendedActionIcon;
        case "approved":
        case "approved_staged":
        case "applied":
        case "closed":
        case "task_created":
        case "rolled_back":
            return SuccessIcon;

        case "apply_failed":
            return AlertIcon;
        case "declined":
        case "iso_rejected":
            return DeclineIcon;
        case "waiting_iso":
        case "applying":
        case "expired":
        default:
            return null;
    }
};

export default ExpertQueueCardStatusIcon;
